export default {
	test1: async (val, funcName) => {
		// return new Promise((resolve) => {
		// 	import(`jscomponents//formatter-functions/${funcName}/index.js`).then((test1) => {
		// 		console.log({test1});
		// 		if (test1) if (test1.default) resolve(test1.default(val));
		// 	});
		// });
		// return new Promise((resolve) => {
		// 	import("./formatter-functions/test1/index.js").then((test1) => {
		// 		console.log({test1});
		// 		if (test1) if (test1.default) resolve(test1.default(val));
		// 	});
		// });
	},
};
